export default "__VITE_ASSET__25aSCY1k__"